import React, {useEffect, useState} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faBackwardStep, faChevronDown, faChevronUp, faCircle, faPencilAlt, faPlay, faPlus, faSquare, faWarning} from "@fortawesome/free-solid-svg-icons";
import {faFlag, faTrashCan} from "@fortawesome/free-regular-svg-icons";
import {reset_batch, run_batch, stop_batch} from "../service/batch";
import "./batch.scss";

import SensorIcon from "../img/sensor.svg";
import ActuatorIcon from "../img/actuator.svg";
import SensorActuatorIcon from "../img/sensor-actuator.svg";

const Batch = ({batch, keyFrames, handleDeleteBatch, handleDeleteKeyframe, handleOpenAddKeyframe, handleOpenEditKeyframe, variables: availableVariables, devices: availableDevices}) => {
    //playbar
    const [running, setRunning] = useState(false);
    const [collapsed, setCollapsed] = useState(localStorage.getItem("collapsed_batch_" + batch.uuid) === "true");

    const [ellapsed, setEllapsed] = useState(0);
    const startTimeRef = React.useRef(0);
    const intervalRef = React.useRef(null);

    // Waits for 10 seconds in the end
    let keyframe_max_delay = 5000 + (keyFrames.length ? Math.max(...keyFrames.filter(keyframe => keyframe.batch === batch.uuid).map(keyframe => keyframe.delay)) : 0);
    let max_time_slots = Math.floor(keyframe_max_delay / 5000);

    const variables = keyFrames.filter(keyframe => keyframe.type === "variable_change" && keyframe.batch === batch.uuid);
    const actuations = keyFrames.filter(keyframe => keyframe.type === "actuation" && keyframe.batch === batch.uuid);
    const data_log_error = keyFrames.filter(keyframe => keyframe.type === "data_log" && keyframe.batch === batch.uuid && keyframe.value.data?._error);

    const variable_types = variables.reduce((acc, keyframe) => {
        if (!acc[keyframe.variable]) {
            acc[keyframe.variable] = [];
        }
        acc[keyframe.variable].push(keyframe);
        return acc;
    }, {});

    const device_types = actuations.reduce((acc, keyframe) => {
        let device_designation = keyframe.keyframe_data?.device?.uuid;
        if (!acc[device_designation]) {
            acc[device_designation] = [];
        }
        acc[device_designation].push(keyframe);
        return acc;
    }, {});


    useEffect(() => {
        let running = batch.status === "running"
        setRunning(running);
        //setPlayBarPosition(running ? 100 : 0)
    }, [batch.status]);

    useEffect(() => {
        if (running) {
            startTimeRef.current = Date.now();
            intervalRef.current = setInterval(() => {
                setEllapsed(Date.now() - startTimeRef.current);
            }, 10);
            return () => clearInterval(intervalRef.current);
        }
    }, [running])

    const handlePlay = async () => {
        await run_batch(batch.uuid);
    }


    const handleStop = async () => {
        await stop_batch(batch.uuid);
    }

    const handleReset = async () => {
        await reset_batch(batch.uuid);
    }

    const toggleCollapsed = () => {
        localStorage.setItem("collapsed_batch_" + batch.uuid, !collapsed);
        setCollapsed(!collapsed);
    }

    const batchStatusTrans = {
        "new": "Simulação por iniciar",
        "completed": "Simulação concluída",
        "running": "Simulação a decorrer",
        "stopped": "Simulação parada",
    }

    return (<div className={"Batch card w-100 mb-3" + (collapsed ? " collapsed" : "")}>
        <div className={"card-header"}>
            <div className={"card-header-content"}>
                <div className={"collapse-button"} onClick={toggleCollapsed}>
                    <FontAwesomeIcon icon={collapsed ? faChevronDown : faChevronUp}/>
                </div>
                <h4 onClick={toggleCollapsed}>{batch.designation}</h4>
                <div className={"batch-status " + batch.status}>
                    <FontAwesomeIcon icon={faCircle}/>
                    {batchStatusTrans[batch.status]}
                    {batch.status === "running" && <small> tempo atual: {Math.floor(ellapsed / 1000)} segundos</small>}
                </div>
                <div className={"batch-controls"}>
                    <div className={"control-button" + (running ? " hide" : "")} onClick={handlePlay}>
                        <FontAwesomeIcon icon={faPlay}/>
                    </div>
                    <div className={"control-button" + (running ? "" : " hide")} onClick={handleStop}>
                        <FontAwesomeIcon icon={faSquare}/>
                    </div>
                    <div className={"control-button"} onClick={handleReset}>
                        <FontAwesomeIcon icon={faBackwardStep}/>
                    </div>
                </div>
            </div>
            <div className={"delete-batch"} onClick={handleDeleteBatch(batch.uuid)}>
                <FontAwesomeIcon icon={faTrashCan}/>
            </div>
        </div>
        <div className={"batch-body"}>
            <div className={"batch-delay-header"}> {/*Delay header*/}
                <span></span>
                <h6>0</h6>
                {Array.from({length: max_time_slots}, (_, i) => i).map((slot, index) => {
                    return <h6 key={index}>{(slot + 1) * 5}s</h6>
                })}
            </div>
            <div className={"timeline-steps"}>
                {Array.from({length: max_time_slots + 1}, (_, i) => i).map((slot, index) => {
                    return <div key={index} className={"step"}></div>
                })}
            </div>
            {data_log_error.length > 0 && <div className={"errors"}>
                <div className={"line"} style={{marginTop: "1em"}}>
                    <div className={"name"}/>
                    <div className={"line-content"}>
                        {data_log_error?.map((keyframe, index) => {
                            return (<div key={keyframe.id + "_" + index} className={"keyframe actuation"} style={{
                                left: `${keyframe.delay / 1000 * 120 / 5}px`
                            }}>
                                <h6 className={"data_log_error"}>
                                    <FontAwesomeIcon icon={faWarning}/>
                                    <strong>Erro</strong>
                                    <div>
                                        {keyframe.value.data?._error}
                                        <pre>{JSON.stringify(keyframe.value.data?._meta, null, 2)}</pre>
                                    </div>
                                </h6>
                            </div>)
                        })}
                    </div>
                </div>
            </div>}
            <div className={"variables"}>
                {availableVariables?.map(({name: variable, uuid}, index) => {
                    return <div key={uuid} className={"line"}>
                        <div className={"name"}>
                            <h5>#{variable}</h5>
                            <div className={"button-round button-add align-self-center"} onClick={() => handleOpenAddKeyframe(batch.uuid, variable)}>
                                <FontAwesomeIcon icon={faPlus}/>
                            </div>
                        </div>
                        <div className={"line-content"}>
                            {variable_types[variable]?.map((keyframe) => {
                                return (<div key={keyframe.id} className={"keyframe bg-" + (index % 5 + 1)} style={{
                                    left: `${(keyframe.delay / 1000) * 120 / 5}px`,
                                }} onClick={(e) => {
                                    e.stopPropagation();
                                    handleOpenEditKeyframe(keyframe)
                                }}>
                                    <h6>{keyframe.value}</h6>
                                    <div className={"delete-keyframe"}>
                                        <FontAwesomeIcon icon={faPencilAlt}/>
                                    </div>
                                </div>)
                            })}

                        </div>
                    </div>
                })}
            </div>

            <div className={"separator"}/>

            <div className={"devices"}>
                {availableDevices?.map((device, index) => {
                    if (device.type !== "actuator" && (device.type === 'sensor' || !device.variables?.split(",").find(v => variable_types[v])))
                        return null;
                    return <div key={device.uuid} className={"line"}>
                        <div className={"name"}>
                            <img className={"icon"} src={{
                                sensor: SensorIcon,
                                actuator: ActuatorIcon,
                                "sensor-actuator": SensorActuatorIcon,
                            }[device.type]}/> <h5>{device.designation}</h5>
                        </div>
                        <div className={"line-content actuation"} style={{
                            width: `${ellapsed / 1000 * 120 / 5}px`
                        }}>
                            {device_types[device.uuid]?.map((keyframe, index) => {
                                return (<div key={keyframe.id + "_" + index} className={"keyframe actuation"} style={{
                                    left: `${keyframe.delay / 1000 * 120 / 5}px`
                                }}>
                                    <h6>
                                        <FontAwesomeIcon icon={faFlag}/>
                                        Estado: <strong>{typeof keyframe.value === 'string' ? keyframe.value : JSON.stringify(keyframe.value)}</strong>
                                    </h6>
                                </div>)
                            })}
                        </div>
                    </div>
                })}
            </div>
            {/*{keyFrames.filter(keyframe => keyframe.type === "variable_change" && keyframe.batch === batch.uuid).map((keyframe, index) => {
                return (<div key={index} className={"keyframe"} style={{
                    left: `${keyframe.delay / keyframe_max_delay * 66.66}%`
                }}>
                    <h6>{keyframe.variable}</h6>
                    <h6>{keyframe.value}</h6>
                    <div className={"delete-keyframe"} onClick={() => handleOpenEditKeyframe(keyframe)}>
                        <FontAwesomeIcon icon={faPencilAlt}/>
                    </div>
                </div>)
            })}
            {keyFrames.filter(keyframe => keyframe.type === "actuation" && keyframe.batch === batch.uuid).map((keyframe, index) => {
                return (<div key={index} className={"keyframe actuation"} style={{
                    left: `${keyframe.delay / keyframe_max_delay * 66}%`
                }}>
                    <h6>{keyframe.keyframe_data.device?.designation}</h6>
                    <h6>{keyframe.value}</h6>
                </div>)
            })}*/}
            <div className={"play-bar"} style={{
                left: `${180 + (ellapsed / 1000 * 120 / 5)}px`,
                //display: running ? "block" : "none",
                //transitionDuration: `${running ? keyframe_max_delay : 0}ms`,
            }}>
                <div className={"play-bar-top"}/>
            </div>
        </div>
    </div>)
}

export default Batch;
